import React, { useState } from "react";
import { TextField, Button, Box, Typography, CircularProgress } from "@mui/material";
import Api, { setCurrentUser } from "../../api2";
import { ThongBao } from "../Lib/componentLibrarys";
import { useDispatch } from "react-redux";
import userReducer from "../../redux/slice/userSlice";
import { useNavigate } from "react-router-dom";
import backgroundLogin from "../../assets/images/backgroundLogin.svg";
import favicon from "../../assets/images/logoCaChinhBong.png";
import { setCurrentUser2 } from "../../api_danhmuc";


const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async () => {
      if (!username || !password) {
          setError("Vui lòng nhập đầy đủ thông tin!");
          return;
      }
      setError("");

      setLoading(true)

      new Api()
          .Login({ data: { userName: username, password: password } })
          .then((res) => {
              if (!res || res.code !== 200) {
                  setError("Sai tài khoản hoặc mật khẩu!");
                  return;
              }
              dispatch(userReducer.actions.setUserInfo(res?.data));
              localStorage.setItem('accessToken', res?.data?.token)
              navigate("/");

              // Ví dụ: 1 phút sau sẽ thực hiện hành động, sau đó cứ mỗi 1 phút lại thực hiện tiếp
                // const intervalId = setInterval(() => {
                //   new Api()
                //     .RefreshToken({ data: { accessToken: res?.data?.token, refreshToken: res?.data?.refresh_token } })
                //     .then((res) => {
                //       if (!res || res.code !== 200) {
                //           ThongBao({ status: "error", message: "Lỗi làm mới token!" });
                //           return;
                //       }
                //       localStorage.setItem('accessToken', res?.data?.newAccessToken);
                //       setCurrentUser({ access_token: res?.data?.newAccessToken });
                //       setCurrentUser2({ access_token: res?.data?.newAccessToken });
                //     })
                // }, 3000 * 1000);
          })
          .catch(() => {
              ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          })
          .finally(() => {
            setLoading(false);
          })

          
  };

  const handleKeyDown = (e) => {
      if (e.key === "Enter") {
          handleLogin();
      }
  };

  if (loading) {
    return (
      <div className="flat">
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  return (
      <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            minHeight: "100%",
            overflow: "hidden",
            backgroundImage: `url('${backgroundLogin}')`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
      >
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <div>
            <img style={{ width: 100, height: 100 }} src={favicon}></img>
          </div>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#24408A' }}>
            SỞ KHOA HỌC VÀ CÔNG NGHỆ PHÚ YÊN
          </div>
          <div style={{ fontSize: 18, fontWeight: 600, color: '#40A7DE' }}>
            HỆ THỐNG QUẢN LÝ CHỈ DẪN ĐỊA LÝ CÁ CHÌNH BÔNG PHÚ YÊN
          </div>
        </div>  
          <Box
            sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                p: 3,
                boxShadow: 3,
                bgcolor: "white",
                borderRadius: 2,
            }}
        >
            <Typography variant="h6" gutterBottom textAlign="center" style={{ color: 'black', fontWeight: 500 }}>
                ĐĂNG NHẬP
            </Typography>
            <TextField
                fullWidth
                label="Tên đăng nhập"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                margin="normal"
                onKeyDown={handleKeyDown}
            />
            <TextField
                fullWidth
                label="Mật khẩu"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                margin="normal"
                onKeyDown={handleKeyDown}
            />
            <Box sx={{ height: 18, display: "flex", justifyContent: "center", alignItems: "center" }}>
                {error && (
                    <Typography color="error" variant="body2" textAlign="center">
                        {error}
                    </Typography>
                )}
            </Box>
            <Button variant="contained" style={{ backgroundColor: '#40A7DE' }} fullWidth onClick={handleLogin} sx={{ mt: 1 }}>
                Đăng nhập
            </Button>
        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: 10,
            left: "50%",
            transform: "translateX(-50%)",
            textAlign: "center",
            backgroundColor: '#bdbdbd94',
            padding: '10px 35px 10px 35px',
            borderRadius: '30px',
            color: 'white'
          }}
        >
          <Typography variant="body2" sx={{ fontSize: 14, fontWeight: 600}}>
            Phiên bản: 1.0.0.0
          </Typography>
          <Typography variant="body2" sx={{ fontSize: 14, fontWeight: 600}}>
            Bản dịch 20250220
          </Typography>
        </Box>
      </Box>
  );
};

export default Login;